import React from 'react';
import { Box } from 'modules/ui/primitives';

export const TimelineDot = () => (
  <Box height="8px" width="8px" borderRadius="40px" backgroundColor="ui.line" />
);
